import React, { useCallback } from "react"
import styled from "styled-components"
import Img, { FluidObject } from "gatsby-image"
import ButtonBase from "./Button"
import { navigate, Link } from "gatsby"
import ArowIcon from "../../images/icons/small-arrow.png"

type Props = {
  name: string
  price: number
  description: string
  link: string
  image: FluidObject
  type: string
}

const ApartmentBlockContainer = styled.div`
  padding: var(--gutter-m);
  background-color: white;
`

const ApartmentBlockImage = styled(Img)`
  max-height: 230px;
`

const ApartmentDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

const ApartmentName = styled.p`
  text-transform: uppercase;
  font-size: 28px;
  font-weight: 400;
`

const ApartmentPrice = styled.p`
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 400;

  strong {
    font-weight: 700;
  }
`

const ApartmentDescription = styled.p`
  width: 430px;
  max-width: 100%;
  text-transform: uppercase;
  margin: 15px 0px 30px;
  line-height: 26px;
  font-size: 14px;

  @media (${({ theme }): string => theme.screenSizes.sm}) {
    margin: var(--gutter-s) 0px var(--gutter-m);
  }
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const Button = styled(ButtonBase)`
  margin-right: var(--gutter-m);
  margin-bottom: var(--gutter-s);
`

const ApplyNowBtn = styled.a`
  margin-right: var(--gutter-m);
  background-color: transparent;
  padding: 22px 45px;
  border: 1.5px solid #1f1f1f;
  cursor: pointer;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
  font-family: "DIN";
  transition: all ease 300ms;
  color: #1f1f1f;

  &:hover,
  &:focus,
  &:active {
    border: 1.5px solid #1f1f1f;
    background-color: #1f1f1f;
    color: #f4f2f6;
  }
  @media (${({ theme }): string => theme.screenSizes.sm}) {
    margin-bottom: var(--gutter-s);
  }
`

const BookViewingButton = styled(Link)`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  padding: var(--gutter-s) 0px;

  img {
    vertical-align: middle;
    width: 6px;
    margin-left: 10px;
    transition: all ease 300ms;
    margin-bottom: 2px;
  }

  &:hover {
    img {
      margin-left: 5px;
    }
  }
`

const ApartmentBlock: React.FC<Props> = ({
  name,
  price,
  description,
  link,
  image,
  type,
  ...props
}: Props) => {
  const handleClick = useCallback(() => {
    navigate(link)
  }, [link])
  return (
    <ApartmentBlockContainer {...props}>
      <ApartmentBlockImage fluid={image} />
      <ApartmentDetailHeader>
        <ApartmentName>{name}</ApartmentName>
        <ApartmentPrice>
          From <strong>R{price?.toLocaleString("en") ?? 0}</strong>
        </ApartmentPrice>
      </ApartmentDetailHeader>

      <ApartmentDescription>{description}</ApartmentDescription>
      <ButtonContainer>
        <Button onClick={handleClick}>Explore Unit</Button>
        <ApplyNowBtn
          href="https://my.ooba.co.za/#/public/register?invite=b839ac3b-9c8d-48e1-944d-a08f964501f8"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apply Now
        </ApplyNowBtn>
        <BookViewingButton
          id={name}
          to="contact-us"
          state={{ apartmentType: type }}
        >
          Book a viewing{" "}
          <img src={ArowIcon} alt="Menlyn Maine - Book a viewing" />
        </BookViewingButton>
      </ButtonContainer>
    </ApartmentBlockContainer>
  )
}

export default ApartmentBlock
